import React, { useState } from 'react';
import { Calendar, momentLocalizer, Views, View } from 'react-big-calendar';
import moment from 'moment';
import { DateTime } from 'luxon';
import { useNavigate } from 'react-router-dom';

import { EventItem } from './EventsPage'; // Assuming EventItem is exported from EventsPage or a types file

// Setup the localizer by providing the moment Object
const localizer = momentLocalizer(moment);

interface RBCEvent {
  id: string;
  title: string;
  start: Date;
  end: Date;
  allDay?: boolean;
  resource?: any; // Can be the original EventItem
}

interface EventCalendarViewProps {
  events: EventItem[];
}

// Define the views that the calendar will support
const allViews: View[] = [Views.MONTH, Views.WEEK, Views.DAY, Views.AGENDA];

const EventCalendarView: React.FC<EventCalendarViewProps> = ({ events }) => {
  const navigate = useNavigate();

  const [currentCalendarView, setCurrentCalendarView] = useState<View>(Views.MONTH);
  const [currentCalendarDate, setCurrentCalendarDate] = useState<Date>(DateTime.now().toJSDate());

  const rbcEvents: RBCEvent[] = events.map(event => {
    const startDate = DateTime.fromSeconds(parseInt(event.startsAt, 10)).toJSDate();
    const endDate = DateTime.fromSeconds(parseInt(event.endsAt, 10)).toJSDate();
    
    return {
      id: event.id,
      title: event.name,
      start: startDate,
      end: endDate,
      resource: event, // Store the original event data if needed for onClick etc.
    };
  });

  const handleSelectEvent = (event: RBCEvent) => {
    console.log('event', event);
    // Placeholder for what happens when an event is clicked on the calendar
    // For now, just log the event. In future, could open a modal or navigate.
    // alert(`Event: ${event.title}\nTime: ${event.start.toLocaleString()}`);

    // navigate to the event page
    navigate(`/events/${event.id}`);
  };

  const handleViewChange = (view: View) => {
    setCurrentCalendarView(view);
  };

  const handleNavigate = (newDate: Date, view: View, action: string) => {
    setCurrentCalendarDate(newDate);
    // If you want the view to change based on navigation (e.g. clicking a day in month view goes to day view)
    // you might need to also call setCurrentCalendarView(view) here, 
    // but typically the calendar handles this transition itself if the 'view' prop is managed.
  };

  return (
    <div style={{ height: '600px' }} className="event-calendar-container">
      <Calendar
        localizer={localizer}
        events={rbcEvents}
        startAccessor="start"
        endAccessor="end"
        style={{ flexGrow: 1 }}
        onSelectEvent={handleSelectEvent}

        views={allViews}                   // Pass the available views
        view={currentCalendarView}         // Controlled current view
        onView={handleViewChange}          // Callback for when the view changes
        
        date={currentCalendarDate}         // Controlled current date
        onNavigate={handleNavigate}        // Callback for when the date/navigation changes
        // defaultDate is removed as date prop now controls it.
      />
    </div>
  );
};

export default EventCalendarView;
